import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiCity\GetWikiCityActivitiesByIdController::__invoke
* @see app/Http/Controllers/WikiCity/GetWikiCityActivitiesByIdController.php
* @route '/api/city/{city}/activities'
*/
const GetWikiCityActivitiesByIdController = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiCityActivitiesByIdController.url(args, options),
    method: 'get',
})

GetWikiCityActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/city/{city}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiCity\GetWikiCityActivitiesByIdController::__invoke
* @see app/Http/Controllers/WikiCity/GetWikiCityActivitiesByIdController.php
* @route '/api/city/{city}/activities'
*/
GetWikiCityActivitiesByIdController.url = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { city: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { city: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            city: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        city: typeof args.city === 'object'
        ? args.city.id
        : args.city,
    }

    return GetWikiCityActivitiesByIdController.definition.url
            .replace('{city}', parsedArgs.city.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiCity\GetWikiCityActivitiesByIdController::__invoke
* @see app/Http/Controllers/WikiCity/GetWikiCityActivitiesByIdController.php
* @route '/api/city/{city}/activities'
*/
GetWikiCityActivitiesByIdController.get = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiCityActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiCity\GetWikiCityActivitiesByIdController::__invoke
* @see app/Http/Controllers/WikiCity/GetWikiCityActivitiesByIdController.php
* @route '/api/city/{city}/activities'
*/
GetWikiCityActivitiesByIdController.head = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetWikiCityActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetWikiCityActivitiesByIdController